import apiFetch from '../apiFetch'

export default function (idTipoDosis) {
  return apiFetch({endPoint: `TipoDosis/getTipoDosis?idTipoDosis=` + idTipoDosis, method: 'GET', body: null})
}